import React, { useState, useEffect, useRef } from "react";
import classes from "./Header.module.scss";
import logo from "../../../assets/img/header/logo.svg";

import { Link, NavLink, useLocation } from "react-router-dom";
import Button from "../Button/Button";

const Header = () => {
  //const [localA, setLocalA] = useState(false);
  const [burgerA, setBurgerA] = useState(false);

  useEffect(() => {

    const body = document.querySelector("body");
    if (burgerA) {
      body.classList.add("lock");
    } else {
      body.classList.remove("lock");
    }
  }, [burgerA])

  return (
    <div className={classes.header}>
      <div className={classes.headerBody}>
        <div className={classes.headerRow}>
          <div className={burgerA ? [classes.headerRowNavWrapScroll, classes.active, ""].join(" ") :
            [classes.headerRowNavWrapScroll, ""].join(" ")
          }
          >
            <nav className={[classes.headerRowNavWrap, ""].join(" ")}>
              <div className={[classes.headerRowNav, ""].join(" ")}>
                <NavLink to="/" className={[classes.headerRowNavItem, ""].join(" ")}>
                  Home
                </NavLink>
                <NavLink to="/" className={[classes.headerRowNavItem, ""].join(" ")}>
                  About
                </NavLink>
                <NavLink to="/" className={[classes.headerRowNavItem, ""].join(" ")}>
                  Services
                </NavLink>
                <NavLink to="/" className={[classes.headerRowNavItem, ""].join(" ")}>
                  Contact
                </NavLink>
              </div>


            </nav>
          </div>


          <NavLink to={"/"} className={[classes.headerRowLogo, ""].join(" ")}>
            <img src={logo} alt="" />
          </NavLink>
          <div className={[classes.headerRowRight, ""].join(" ")}>
            <Button>
              book
            </Button>
            <div className={burgerA ? [classes.headerRowRightBurger, classes.active, ""].join(" ") :
              [classes.headerRowRightBurger, ""].join(" ")
            } onClick={() => { setBurgerA(!burgerA) }}
            >
              <span></span><span></span><span></span>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
